import styled from "styled-components";
import {Table} from "antd";

export const RoundedTable = styled(Table)`
    border-radius: 15px;
    border: 1px solid #e7ebf3;
    overflow: hidden;
    width: 100%;
`;
